import { useSelector } from "react-redux";
import { useParams } from "react-router";

import { EventSchedule } from "Bands/containers";
import { CreateScheduleBlockEntryForm } from "Bands/containers";
import { dataMetaSelector, eventBlockSelectorCreator } from "Bands/state";
import { BAND_ACTIONS, EventBlocks, IScheduleBlock, IScheduleBlockEntry } from "Bands/types";
import { copy } from "shared/assets";
import { Clock } from "shared/assets/icons";
import { Button, Card, Loader, Title } from "shared/components";
import { Spacer } from "shared/layout";
import { IAPIState, ITheme } from "shared/types";
import { BAND_PATHS } from "Bands/router";
import { useEventRoute } from "Bands/utils";
import FourOhFour from "shared/pages/FourOhFour/FourOhFour";
import { FourOhThree } from "shared/pages";
import { mapUserPermissions } from "shared/utils";
import { useState } from "react";
import CopyBlockModal from "../copy-block/CopyBlockModal";

const scheduleBlockCopy = copy.scheduleBlock;

export const EditScheduleBlockPage = () => {
  const { blockId } = useParams<{ blockId: string }>();
  const { pushRoute } = useEventRoute();

  const scheduleBlockSelector = eventBlockSelectorCreator(blockId, EventBlocks.schedule);
  const scheduleBlock = useSelector(scheduleBlockSelector) as IScheduleBlock;

  const [showEditEntryModal, setShowEditEntryModal] = useState<IScheduleBlockEntry | null>(null);

  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.getEventScheduleBlocks));

  const renderContent = () => {
    if (!scheduleBlock) return <Loader />; // fetching

    return (
      <Spacer size="l">
        <CreateScheduleBlockEntryForm blockId={blockId} showEditEntryModal={showEditEntryModal} />
        {!!scheduleBlock?.entries.length && (
          <Spacer size="m">
            <Title asComponent="h3" size="m">
              {scheduleBlockCopy.view.title}
            </Title>
            <EventSchedule
              blockId={blockId}
              entries={scheduleBlock?.entries}
              showActions
              showEditEntryModal={showEditEntryModal}
              setShowEditEntryModal={setShowEditEntryModal}
            />
          </Spacer>
        )}
        <Button onClick={() => pushRoute(BAND_PATHS.BAND_EVENT)} theme={ITheme.secondary}>
          {copy.form.finish}
        </Button>
      </Spacer>
    );
  };

  if (apiMeta?.status !== IAPIState.pending && !scheduleBlock) return <FourOhFour />;

  if (scheduleBlock && !mapUserPermissions(scheduleBlock.permissions || []).EDIT) {
    return <FourOhThree />;
  }

  return (
    <Card
      title={scheduleBlockCopy.edit.title.replace("%title", scheduleBlock?.title || "...")}
      icon={Clock}
    >
      <Spacer size="m">
        <CopyBlockModal blockType={EventBlocks.schedule} deleteBlockId={blockId} />
        {renderContent()}
      </Spacer>
    </Card>
  );
};
